import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { CheckCircle, Gift, Mail, Phone, ArrowLeft, Download } from "lucide-react";
import { useSEO } from "../hooks/useSEO";

const GutscheinErfolg = () => {
  useSEO({
    title: "Gutschein erfolgreich gekauft | Klartech Müritz",
    description: "Vielen Dank für Ihren Kauf! Der Gutschein wurde an Ihre E-Mail-Adresse gesendet.",
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white">
      {/* Header */}
      <header className="sticky top-0 z-50 border-b border-slate-200 bg-white shadow-sm">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3 md:py-4">
          <Link to="/" className="flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_tech-support-mvp/artifacts/88uemucq_LogoKlartech%20%281%29.png"
              alt="Klartech Müritz Logo"
              className="h-10 md:h-12 w-auto object-contain"
            />
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-2xl px-6 py-16 md:py-24">
        <div className="text-center">
          {/* Success Icon */}
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-green-100 mb-8">
            <CheckCircle className="h-10 w-10 text-green-600" />
          </div>

          <h1 className="text-3xl md:text-4xl font-black text-slate-900 mb-4">
            Vielen Dank für Ihren Kauf!
          </h1>
          
          <p className="text-xl text-slate-600 mb-8">
            Der IT-Support Geschenkgutschein wurde erfolgreich erstellt.
          </p>

          <Card className="mb-8 text-left">
            <CardContent className="p-6 space-y-4">
              <div className="flex items-start gap-4">
                <div className="p-2 rounded-lg bg-blue-100">
                  <Mail className="h-5 w-5 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900">E-Mail prüfen</h3>
                  <p className="text-slate-600">
                    Sie erhalten in Kürze eine E-Mail mit Ihrer Kaufbestätigung von Stripe.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="p-2 rounded-lg bg-green-100">
                  <Gift className="h-5 w-5 text-green-600" />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900">Gutschein einlösen</h3>
                  <p className="text-slate-600">
                    Der Beschenkte kann den Gutschein telefonisch oder per E-Mail einlösen und einen Termin vereinbaren.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="p-2 rounded-lg bg-purple-100">
                  <Phone className="h-5 w-5 text-purple-600" />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900">Kontakt</h3>
                  <p className="text-slate-600">
                    Bei Fragen erreichen Sie uns unter{" "}
                    <a href="tel:+4915128958006" className="text-[--brand-primary] font-semibold hover:underline">
                      01512 895 800 6
                    </a>
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-8">
            <p className="text-amber-800 text-sm">
              <strong>Hinweis:</strong> In den nächsten 24 Stunden erhalten Sie den personalisierten Gutschein als PDF per E-Mail, den Sie ausdrucken und verschenken können.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button variant="outline" className="gap-2">
                <ArrowLeft className="h-4 w-4" />
                Zur Startseite
              </Button>
            </Link>
            <Link to="/gutschein">
              <Button className="gap-2 bg-[--brand-primary] hover:bg-[--brand-primary-dark]">
                <Gift className="h-4 w-4" />
                Weiteren Gutschein kaufen
              </Button>
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 bg-slate-50 py-8 mt-auto">
        <div className="mx-auto max-w-7xl px-6 text-center text-slate-600">
          <p>© {new Date().getFullYear()} Klartech Müritz. Alle Rechte vorbehalten.</p>
        </div>
      </footer>
    </div>
  );
};

export default GutscheinErfolg;
